var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"spectrum-ActionButton",class:{
    'is-selected': _vm.isSelected,
    'spectrum-ActionButton--quiet': _vm.quiet,
  },attrs:{"disabled":_vm.disabled}},[_vm._t("default"),(_vm.label)?_c('span',{staticClass:"spectrum-ActionButton-label",domProps:{"textContent":_vm._s(_vm.label)}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }